import { services } from '../services';
var action = "property/handover";

export const propertyhandoverService = {
    getList,
    getOne,
    insert,
    update,
    remove,
    getStatusList,
    getProperty,
    approved,
    dennied,
};

function getList(param = '') {
    return services.restApi(`${action}${param}`, 'GET');
}

function getOne(id) {
    return services.restApi(`${action}/${id}`, 'GET');
}

function insert(object) {
    return services.restApi(`${action}`, 'POST', object);
}

function update(id, object) {
    return services.restApi(`${action}/${id}`, 'PUT', object);
}

function remove(id) {
    return services.restApi(`${action}/${id}`, 'DELETE');
}

function getStatusList(param = '') {
    return services.restApi(`/property/handover/status${param}`, 'GET');
}

function getProperty(id) {
    return services.restApi(`property/handover/property/${id}`, 'GET');
}

function approved(id) {
    return services.restApi(`property/handover/approve/${id}`, 'POST');
}

function dennied(id) {
    return services.restApi(`property/handover/denie/${id}`, 'POST');
}